import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import AccessTickets from "./AccessTickets";
import Section from "./Section";
import ApprovalRequest from "./ApprovalRequest";
// import CarparkOccupancyRate from "./CarparkOccupancyRate";
//import ManualOverwrite from "./ManualOverwrite"
import BillErrors from "./BillErrors";
import Revenue from "./Revenue";
import { useSelector, useDispatch } from "react-redux";
import { getCarParks as onGetCarParks } from "../../store/carpark/actions";
import { getRoles as onGetRoles } from "../../store/roles/actions";
import { getSessionTickets as onGetSessionTickets } from "../../store/tickets/actions";
import { getSeasonPasses as onGetSeasonPasses } from "../../store/season-pass/actions";
import { seasonPasstSatusTypes } from "constants/common";
import { getDashboardRevenue as onGetDashboardRevenue, getLotsSold as onGetLotsSold } from "../../store/dashboard/actions"
import { getBillErrors as onGetBillErrors } from "../../store/bill/actions"
import moment from "moment"
import LotsSold from "./LotsSold"
import _ from "lodash";

const sizePerPage = 100;

const Dashboards = () => {
  const dispatch = useDispatch()

  const [role, setRole] = useState(null)
  const [sessionType, setSessionType] = useState("all")
  const [occupanyDurationType, setOccupancyDurationType] = useState({
    timeRangeStart: ["09", "00"],
    timeRangeEnd: ["17", "00"],
    day: "",
    dateRangeStart: moment().subtract(6, "M").format("YYYY-MM-DD"),
    dateRangeEnd: moment().format("YYYY-MM-DD"),
    type: "months",
  })
  const {
    carParks,
    seasonPassData,
    roles,
    sessionTickets,
    revenueData,
    occupancyData,
    billErrors,
    lotsSold,
    isLoadingLotsSold,
  } = useSelector(state => ({
    carParks: state.carPark.carParkList,
    seasonPassData: state.seasonPass.seasonPassList,
    roles: state.roles.roleList,
    sessionTickets: state.sessionTickets.sessionTicketList,
    revenueData: state.dashboard.revenueData,
    // occupancyData: state.dashboard.occupancyData,
    billErrors: state.bills.billErrors,
    lotsSold: state.dashboard.lotsSold,
    isLoadingLotsSold: state.dashboard.isLoadingLotsSold,
  }))

  useEffect(() => {
    dispatch(onGetLotsSold());
    dispatch(onGetCarParks({ status: "Available" }));
    dispatch(onGetSeasonPasses({ status: seasonPasstSatusTypes.Available }));
    dispatch(onGetRoles());
   // dispatch(onGetSessionTickets());
    dispatch(onGetDashboardRevenue());
    dispatch(onGetBillErrors({ page: 1, size: 5, isSuccess: false })); // change isSuccess false to true
    //dispatch(onGetDashboardOccupancy({ durationType: occupanyDurationType }))
  }, [])

  // useEffect(() => {
  //   dispatch(onGetDashboardOccupancy({ durationType: occupanyDurationType }))
  // }, [occupanyDurationType])

  useEffect(() => {
    if (role) {
      dispatch(onGetSessionTickets({ size: sizePerPage, role,showUserOnly:true }))
    }
  }, [role])

  useEffect(() => {
    if (sessionType == "guest") {
      dispatch(onGetSessionTickets({ size: sizePerPage, type: "guest",showUserOnly:true  }))
    } else if (sessionType == "all") {
      dispatch(onGetSessionTickets({size: sizePerPage, showUserOnly:true}))
    }
  }, [sessionType])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xs={12}>
              <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 className="mb-0 font-size-18">Dashboard</h4>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xl={8}>
              {/* <Section data={carParks || []} /> */}
              {!_.isEmpty(carParks) && !_.isEmpty(seasonPassData) && !_.isEmpty(lotsSold) && 
              !isLoadingLotsSold && 
               <LotsSold isLoadingLotsSold={isLoadingLotsSold} 
                         carparks={carParks} seasonPass={seasonPassData} 
                         lotsSold={lotsSold}   />}
              <Row>                
                <AccessTickets
                  roles={roles || []}
                  sessionTickets={sessionTickets || []}
                  setRole={setRole}
                  setSessionType={setSessionType}
                />
                <ApprovalRequest />
              </Row>
              {/* <CarparkOccupancyRate
                occupancyData={occupancyData}
                setType={type => {
                  setOccupancyDurationType(type)
                }}
              /> */}
            </Col>
            <Col xl={4}>
              <BillErrors data={billErrors || []} carparks={carParks} />
              {!_.isEmpty(revenueData) && 
              <Revenue data={revenueData} />}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Dashboards
